<template>
  <div class="input-container text-start">
    <label v-if="label" class="form-label">{{ label }}<span v-if="required">*</span></label>

    <div class="input-group mb-0 bg-light-subtle rounded-3 align-items-start">
      <span class="input-group-text text-muted" v-if="icon">
        <i :class="icon"></i>
      </span>

      <textarea
        :class="['form-control', 'form-control-lg', 'border-light', 'bg-light-subtle']"
        :placeholder="placeHolder"
        :rows="rows"
        :value="modelValue"
        @input="onInput"
        :required="required"
        :maxlength="maxlength || null"
        ref="textarea"
        :style="textareaStyle"
      ></textarea>
    </div>

    <div class="d-flex justify-content-between mt-1" v-if="showCounter || helpText">
      <small class="text-muted" v-if="helpText">{{ helpText }}</small>
      <small class="text-muted ms-auto" v-if="showCounter">{{ remainingChars }} {{ counterLabel }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextareaField',
  props: {
    label: { type: String },
    icon: { type: String },
    placeHolder: { type: String, default: '' },
    required: { type: Boolean, default: false },
    modelValue: { type: [String, Number], default: '' },
    rows: { type: Number, default: 3 },
    autoGrow: { type: Boolean, default: false }, // ajustar altura automaticamente
    resize: { type: Boolean, default: true }, // permitir resize do usuário
    maxlength: { type: [Number, String], default: null },
    helpText: { type: String, default: '' }
  },
  data () {
    return {}
  },
  computed: {
    // estilo inline para controlar resize via prop
    textareaStyle () {
      return {
        resize: this.resize ? 'vertical' : 'none',
        overflow: this.autoGrow ? 'hidden' : 'auto'
      }
    },
    currentValue () {
      return String(this.modelValue ?? '')
    },
    showCounter () {
      return this.maxlength !== null && this.maxlength !== undefined
    },
    remainingChars () {
      if (!this.showCounter) return ''
      const max = Number(this.maxlength)
      const len = this.currentValue.length
      return Math.max(0, max - len)
    },
    counterLabel () {
      return this.remainingChars === 1 ? 'caractere' : 'caracteres'
    }
  },
  watch: {
    modelValue () {
      if (this.autoGrow) this.adjustHeight()
    }
  },
  mounted () {
    if (this.autoGrow) this.adjustHeight()
  },
  methods: {
    onInput (e) {
      const val = e.target.value
      this.$emit('update:modelValue', val)
      if (this.autoGrow) this.adjustHeight()
    },
    adjustHeight () {
      // auto-grow: reset height e aplicar scrollHeight
      this.$nextTick(() => {
        const ta = this.$refs.textarea
        if (!ta) return
        ta.style.height = 'auto'
        // adicionar 2px para evitar barra de rolagem em alguns browsers
        ta.style.height = (ta.scrollHeight + 2) + 'px'
      })
    }
  }
}
</script>

<!-- estilo opcional, mantenha scoped se desejar -->
<style scoped>
/* garante que a textarea mantenha o mesmo padding e borda do input */
textarea.form-control {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  min-height: 3.5rem;
  line-height: 1.4;
  border-radius: 0.375rem; /* 2xl-like do seu exemplo */
  box-shadow: none;
}
.input-group-text i {
  font-size: 1.05rem;
}
/* contador pequeno alinhado */
</style>
